import { motion } from "framer-motion";
import { Phone, MessageCircle } from "lucide-react";
import { SITE } from "../../lib/content";

export default function FloatingButtons() {
  return (
    <div className="fixed bottom-5 right-5 z-[70] flex flex-col gap-3" data-testid="floating-buttons">
      <motion.a
        href={`https://wa.me/${SITE.whatsapp}?text=Hi%2C%20I'd%20like%20to%20know%20more%20about%20NK%20Science%20%26%20Physics%20Academy.`}
        target="_blank"
        rel="noreferrer"
        data-testid="float-whatsapp"
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 1, type: "spring", stiffness: 260, damping: 18 }}
        whileHover={{ scale: 1.08 }}
        whileTap={{ scale: 0.94 }}
        className="grid place-items-center h-14 w-14 rounded-full bg-[#25D366] text-white shadow-lg shadow-[#25D366]/30"
        aria-label="Chat on WhatsApp"
      >
        <MessageCircle className="h-6 w-6" />
      </motion.a>
      <motion.a
        href={`tel:${SITE.phoneIntl}`}
        data-testid="float-call"
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 1.1, type: "spring", stiffness: 260, damping: 18 }}
        whileHover={{ scale: 1.08 }}
        whileTap={{ scale: 0.94 }}
        className="grid place-items-center h-14 w-14 rounded-full bg-flame text-white shadow-lg shadow-flame/30"
        aria-label="Call now"
      >
        <Phone className="h-6 w-6" />
      </motion.a>
    </div>
  );
}
